
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"110","height":"36","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"109","height":"35","rx":"7.5","fill":"#fff","stroke":"#AEB1BA"}}),_c('path',{attrs:{"d":"M33.258 18h45.128","stroke":"#AEB1BA","stroke-width":"2"}})])
          )
        }
      }
    